import { UIGameChat } from './UIGameChat/UIGameChat.tsx';
import { UIGameLog } from './UIGameLog/UIGameLog.tsx';
import React, { useMemo, useState } from 'react';
import styles from './UIGameFeeds.module.scss';
import { cloneDeep } from 'lodash-es';
import { GameValidator } from '@colonist/game-mechanic-validators';
import clsx from 'clsx';
import { UIGameVoteContainer } from '../UIGameVote/UIGameVoteContainer.tsx';
import { useGameStore } from '../../store/GameStoreContext.ts';
export function UIGameFeeds({ isChatEnabled, onClickLog, className }) {
    const gameState = useGameStore((state)=>state.gameState);
    const userStates = useGameStore((state)=>state.gameUserStates.userStates);
    const [isLogVisible, setIsLogVisible] = useState(true);
    const [isChatVisible, setIsChatVisible] = useState(true);
    const gameValidator = useMemo(()=>{
        const clonedGameState = cloneDeep(gameState);
        for(const playerColorKey in clonedGameState.playerStates){
            clonedGameState.playerStates[playerColorKey].isConnected = true;
        }
        return new GameValidator(gameState, userStates);
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.responsiveContainer, className)
    }, /*#__PURE__*/ React.createElement(UIGameVoteContainer, {
        className: styles.gameVoteContainer,
        setLogVisible: setIsLogVisible,
        setChatVisible: setIsChatVisible
    }), /*#__PURE__*/ React.createElement(UIGameLog, {
        backgroundColor: "beige",
        gameValidator: gameValidator,
        onClickLog: onClickLog,
        isLogVisible: isLogVisible
    }), isChatEnabled && /*#__PURE__*/ React.createElement(UIGameChat, {
        backgroundColor: "beige",
        gameValidator: gameValidator,
        isChatVisible: isChatVisible,
        isMinimizeable: isChatEnabled
    }));
}
